import i18n from '../i18n';

let key;
if (process.env.NODE_ENV === "development" || window.location.origin.includes("dev")) {
  key = process.env.VUE_APP_STRIPE_TEST_KEY;
} else {
  key = process.env.VUE_APP_STRIPE_LIVE_KEY;
}

export default {
  pk: key,
  stripeAccount: 'acct_1EZgHpD0FTK9EWlI',
  apiVersion: '2020-08-27', // '2019-03-14',
  locale: i18n.locale,
};
